import {ref} from 'vue';

/** Used to prevent router flickering due to navigation */
export function usePreventRouterBlink() {
    const routerViewRef = ref<HTMLDivElement>();

    function handleBeforeLeave() {
        if (routerViewRef.value) {
            routerViewRef.value.style.height = `${routerViewRef.value.offsetHeight}px`;
        }
    }

    function handleAfterEnter() {
        if (routerViewRef.value) {
            routerViewRef.value.style.height = '';
        }
    }

    return {
        routerViewRef,
        routerEvents: {
            'before-leave': handleBeforeLeave,
            'after-enter': handleAfterEnter,
        },
    };
}
